import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import classnames from 'classnames'

const NotificationsUnreadCount = ({ unreadCount }) => {
  const [lastCount, setLastCount] = useState(unreadCount)
  const [animateTs, setAnimateTs] = useState(null)
  const [animate, setAnimate] = useState(false)
  useEffect(() => {
    if ((lastCount || 0) < (unreadCount || 0)) {
      if (typeof lastCount === 'number') {
        setAnimateTs(new Date())
      }
      setLastCount(unreadCount)
    }
  }, [lastCount, unreadCount])
  useEffect(() => {
    let handle
    if (animateTs !== null) {
      setAnimate(true)
      handle = setTimeout(() => {
        setAnimate(false)
        handle = 0
      }, 2000)
    }
    return () => {
      if (handle) clearTimeout(handle)
    }
  }, [animateTs])

  if (unreadCount > 0) {
    return <span className={classnames('d-notification__count', { 'd-notification__count__animate': animate })}>{unreadCount}</span>
  }
  return null
}

export default connect(state => ({ unreadCount: state.notifications.unreadCount }))(NotificationsUnreadCount)



// WEBPACK FOOTER //
// ./src/components/notifications/NotificationsUnreadCount.js